export const LOGIN = '/login';
export const DASH = '/';
export const ACCOUNT = '/account';
export const USERS = '/users';
export const USERDETAILS = '/users/:uid';
export const REQUESTS = '/requests';
export const REQUESTDETAILS = '/requests/:id';
export const OVERVIEW = '/';
export const CONTRACTS = '/contracts';
export const CONTRACTDETAILS = '/contracts/:id';
export const SETTINGS = '/settings';



// WEBPACK FOOTER //
// ./src/routes.js